<template>
  <div class="mb10">
    <div class="mb10 feet-r">
      <!-- 增加一行 -->
      <el-button
        size="small"
        type="primary"
        @click="handleAdd"
      >{{ $t('basicData.AddARow') }}</el-button>

      <!-- 下载/导入 -->
      <importAndDownloadCmp
        :fee-type-list="feeTypeList"
        :stitching-line="stitchingLine"
        :model-list="modelList"
        :get-data-func="onDownloadOffer"
        @importList="onImportList"
      />

      <!-- 清空报价 -->
      <el-popover
        placement="bottom-start"
        trigger="hover"
      >
        <div class="feet">
          <!--清空当前分区-->
          <el-button
            size="small"
            type="primary"
            class="feet-btn"
            @click="onClear"
          >{{ $t('basicData.EmptyCurrentPartition') }}
          </el-button>
          <!--清空所有分区-->
          <el-button
            size="small"
            type="primary"
            class="feet-btn"
            @click="onAllClear"
          >{{ $t('basicData.EmptyAllPartitions') }}
          </el-button>
        </div>
        <!--清空报价-->
        <template #reference>
          <el-button size="small">{{ $t('basicData.ClearTheOffer') }}</el-button>
        </template>
      </el-popover>
    </div>

    <!--车线报价 -->
    <TableCmp
      ref="defaultTableRef"
      :fee-type-list="feeTypeList"
      :model-list="modelList"
      :table-data="getPartitionArr"
      @change="changePartition"
    />
  </div>
</template>

<script>
import { TMP_OBJ, SEPARATOR, setPartitionFun, validate, isKeyValueConsistent } from './utils';
import { cloneDeep } from 'lodash-es';

export default {
  components: {
    TableCmp: () => import('./TableCmp.vue'),
    importAndDownloadCmp: () => import('./importAndDowloadCmp.vue')
  },

  props: {
    // 车线id
    partitionAffiliateId: {
      type: [String, Number],
      default: ''
    },

    // 所有车型
    modelList: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 所有车线
    stitchingLine: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 费用类型
    feeTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    return {
      // 报价
      partitionObj: {}
    };
  },

  computed: {
    partitionComputed() {
      const a = this.stitchingLine;// 车线数据
      return {
        a
      };
    },

    // 监听partitionObj变化
    getPartitionArr() {
      const row = this.partitionObj[this.partitionAffiliateId];
      if (this.partitionAffiliateId && row && row.arr) {
        return this.partitionObj[this.partitionAffiliateId].arr || [];
      }
      return [];
    }
  },

  watch: {
    // 监听车线ID
    partitionComputed: {
      handler() {
        console.log('监听车线ID变化', this.stitchingLine);

        // 选择了车线报价 但是车线没有数据
        if (this.stitchingLine.length === 0) {
          return;
        }

        // 先将之前的数据清空
        for (const key in this.partitionObj) {
          this.$delete(this.partitionObj, key);
        }

        // 初始化
        this.stitchingLine.forEach(item => {
          this.$set(this.partitionObj, item.id, {
            arr: []
          });
        });
      },
      deep: true
      // immediate: true
    }
  },

  methods: {
    // 添加
    handleAdd() {
      try {
        // 车线报价
        if (!this.partitionAffiliateId) {
          this.$message.warning(this.$t('basicData.pleaseSelectVehicleLine'));
          return;
        }
        const model = this.partitionObj[this.partitionAffiliateId]?.arr[0]?.quotationMode || '';
        const isMix = this.partitionObj[this.partitionAffiliateId]?.arr[0]?.isMix || 0;
        console.log(model, '已选model', isMix, this.partitionAffiliateId);
        this.partitionObj[this.partitionAffiliateId].arr.push({
          ...TMP_OBJ,
          isMix,
          quotationMode: model
        });
      } catch (error) {
        console.log(error);
      }
    },

    // table数据回调
    changePartition(arr) {
      if (!this.partitionAffiliateId) {
        return;
      }
      console.log('table数据变化188', this.partitionAffiliateId, arr);
      this.partitionObj[this.partitionAffiliateId].arr = arr;
    },

    /**
     * 提交校验
     *    1. 直接校验当前车线
     *    2. 其他分区填写的数据校验
     */
    async submitForm() {
      // 车线报价
      // 校验是否添加了数据
      {
        const arr = [];
        for (const key in this.partitionObj) {
          if (this.partitionObj[key].arr.length > 0) {
            arr.push(this.partitionObj[key].arr);
          }
        }

        if (arr.length === 0) {
          this.$message.warning(this.$t('basicData.PleaseAddDetails'));
          return false;
        }
      }

      // 先校验当前选中的车线
      {
        const isBool = await this.$refs.defaultTableRef.submitForm();
        if (!isBool) {
          this.$message.warning(this.$t('basicData.CheckFail'));
          return false;
        }
      }
      // 存在其他车线，校验
      {
        const arr = [];
        for (const key in this.partitionObj) {
          const isBool = validate(this.partitionObj[key].arr);
          if (!isBool) {
            arr.push(key);
          }
        }
        // 有校验不通过的车线
        if (arr.length > 0) {
          // 获取不通过的车线名称
          const list = this.stitchingLine.filter(item => {
            return arr.includes(String(item.id));
          }).map(item => {
            return item.name;
          }).join(',');

          this.$message.warning('关联车线《' + list + '》' + this.$t('basicData.CheckFail'));
          return false;
        }
      }

      // 校验，相同车线不能存在多个混合报价
      {
        const arr = [];
        for (const key in this.partitionObj) {
          const isBool = isKeyValueConsistent(this.partitionObj[key].arr, 'isMix');
          if (!isBool) {
            arr.push(key);
          }
        }
        if (arr.length > 0) {
          // 获取车线名称
          const list = this.stitchingLine.filter(item => {
            return arr.includes(String(item.id));
          }).map(item => {
            return item.name;
          }).join(',');

          this.$message.warning('关联车线《' + list + '》' + this.$t('basicData.MultipleMixedQuotationDataExist'));
          return false;
        }
      }

      return true;
    },

    // 设置数据(主要是为父组件提供操作)
    async setData(arr) {
      console.log('setData-250', arr);
      if (arr.length === 0) { return; }

      // 车线报价
      const dataObj = cloneDeep(this.partitionObj);
      const row = await setPartitionFun(arr, dataObj);
      console.log(row, '解析后报价数据');
      for (const key in this.partitionObj) {
        this.partitionObj[key].arr = row[key] && row[key].arr ? row[key].arr : [];
      }
      console.log('车线报价', this.partitionObj);
    },

    /**
     * 获取数据
     */
    getData() {
      const arr = [];
      // 车线报价，将所有数据（二维数组）放入arr（一维数组）中
      Object.entries(this.partitionObj).filter(item => {
        const [, value] = item;
        return value.arr.length > 0;
      }).map(item => {
        const [key, value] = item;
        const list = value.arr.map(item => {
          return {
            ...item,
            lineId: key
          };
        });
        arr.push(...list);
      });
      console.log('干支线报价325', arr);
      return arr.filter(item => item.feeTypeCode);
    },

    // 下载报价回调函数
    onDownloadOffer() {
      const list = this.getData();
      console.log('下载报价数据332', list);
      return list.map(item => {
        const { lineId } = item;

        const obj = {
          ...item
        };

        // 车线名称处理
        {
          const partitionAffiliateObj = this.stitchingLine.find(item => {
            return item.id === lineId;
          });
          if (partitionAffiliateObj) {
            const { name, id } = partitionAffiliateObj;
            obj.partitionAffiliateId = `${name}${SEPARATOR}${id}`;
          }
        }
        return obj;
      });
    },

    /**
     * 导入数据
     * @param {TTableRow[]} arr 导入返回的数据
     */
    onImportList(arr) {
      console.log('importList', arr);

      const list = arr.map(item => {
        const { partitionAffiliateId } = item;
        return {
          ...item,
          lineId: partitionAffiliateId
        };
      });
      this.setData(list);
    },

    // 清空当前分区
    onClear() {
      this.partitionObj[this.partitionAffiliateId].arr = [];
    },

    // 清空所有报价
    onAllClear() {
      for (const key in this.partitionObj) {
        this.partitionObj[key].arr = [];
      }
    }
  }
};
</script>
